import React from "react";

const DEFAULT_TAGS = [
  "Street Gourmand","Le Saint Ange","Coralie cuisine pour vous","Le Fournil de Claix",
  "Le Carpe Diem","Pou’claix rôti","Le coin Gourmand","Marché du Bourg","Tito Pizza",
  "Atelier les mains sur terre",
];

function Pill({ children }) {
  return (
    <span className="mx-2 my-1 inline-block whitespace-nowrap rounded-full bg-neutral-100 text-neutral-700 border border-black/5 px-3 py-1.5 text-sm shadow-[0_2px_8px_rgba(0,0,0,0.06),_inset_0_0_4px_rgba(0,0,0,0.2)]">
      {children}
    </span>
  );
}

function Row({ tags }) {
  return (
    <div className="shrink-0 flex items-center whitespace-nowrap">
      {tags.map((t, i) => (
        <Pill key={`${t}-${i}`}>{t}</Pill>
      ))}
    </div>
  );
}

export default function MarqueeTags({ tags = DEFAULT_TAGS, speed = 75 }) {
  const row = [...tags, ...tags]; 

  const maskFade = {
    WebkitMaskImage:
      "linear-gradient(to right, transparent, black 8%, black 92%, transparent)",
    maskImage:
      "linear-gradient(to right, transparent, black 8%, black 92%, transparent)",
  };

  return (
    <section className="w-full">
      <style>{`
        @keyframes marquee-left { 
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        @keyframes marquee-right { 
          0% { transform: translateX(-50%); }
          100% { transform: translateX(0); }
        }
      `}</style>

      <div className="mx-auto max-w-[1519px] px-4 sm:px-6 lg:px-8">
        <div className="overflow-hidden" style={maskFade}>
          {/* Ligne 1 → gauche */}
          <div
            className="group relative py-2"
            onMouseEnter={(e) => {
              const track = e.currentTarget.querySelector(".track");
              if (track) track.style.animationPlayState = "paused";
            }}
            onMouseLeave={(e) => {
              const track = e.currentTarget.querySelector(".track");
              if (track) track.style.animationPlayState = "running";
            }}
          >
            <div
              className="track flex w-max will-change-transform"
              style={{ animation: `marquee-left ${speed}s linear infinite` }}
            >
              <Row tags={row} />
              {/* Copie stricte à la suite → largeur totale = 2x, donc -50% tombe pile */}
              <Row tags={row} aria-hidden="true" />
            </div>
          </div>

          {/* Ligne 2 → droite */}
          <div
            className="group relative"
            onMouseEnter={(e) => {
              const track = e.currentTarget.querySelector(".track");
              if (track) track.style.animationPlayState = "paused";
            }}
            onMouseLeave={(e) => {
              const track = e.currentTarget.querySelector(".track");
              if (track) track.style.animationPlayState = "running";
            }}
          >
            <div
              className="track flex w-max will-change-transform"
              style={{ animation: `marquee-right ${speed}s linear infinite` }}
            >
              <Row tags={row} />
              <Row tags={row} aria-hidden="true" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}